import React from 'react';

import { FormattedMessage } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import CheckIcon from '@atlaskit/icon/core/check-mark';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const standardEditionColumnStyles = cssMap({
	root: {
		width: '91px',
		height: '333px',
		backgroundColor: token('color.background.input'),
		borderRadius: token('radius.xsmall'),
		borderWidth: token('border.width.selected'),
		paddingTop: token('space.150'),
		boxShadow: token('elevation.shadow.overlay'),
		zIndex: 1,
	},
	textRow: {
		height: '24px',
	},
	limitedText: {
		color: token('color.text.accent.green'),
		font: token('font.body.small'),
	},
});

/**
 * This depicts the checklist of features available in the Standard edition.
 */
export const StandardEditionColumn = ({
	standardPrice,
}: {
	standardPrice: number;
}): React.JSX.Element => {
	const formattedPrice = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(standardPrice);

	return (
		<Flex
			xcss={standardEditionColumnStyles.root}
			direction="column"
			alignItems="center"
			gap="space.200"
		>
			<Flex direction="column" alignItems="center">
				<Text weight="semibold" color="color.text.accent.blue.bolder">
					<FormattedMessage {...messages.standardEdition} />
				</Text>
				<Text weight="semibold" color="color.text.accent.blue.bolder">
					{formattedPrice}
				</Text>
			</Flex>
			<Flex direction="column" gap="space.200" alignItems="center">
				{/* Why not put this in a loop? IMO that's actually less readable. */}
				<CheckIcon spacing="spacious" label="" color={token('color.icon.accent.green')} />
				<CheckIcon spacing="spacious" label="" color={token('color.icon.accent.green')} />
				<CheckIcon spacing="spacious" label="" color={token('color.icon.accent.green')} />
				<CheckIcon spacing="spacious" label="" color={token('color.icon.accent.green')} />
				<CheckIcon spacing="spacious" label="" color={token('color.icon.accent.green')} />
				<Flex
					xcss={standardEditionColumnStyles.textRow}
					justifyContent="center"
					alignItems="center"
				>
					<Box xcss={standardEditionColumnStyles.limitedText}>
						<FormattedMessage {...messages.whiteboardsLimited} />
					</Box>
				</Flex>
			</Flex>
		</Flex>
	);
};
